import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { EntryInput } from "@/types";

export type EditForm = {
  rowsFrom: undefined | number;
  rowsTo: undefined | number;
  big: undefined | EntryInput["big"];
  small: undefined | EntryInput["small"];
  mode: undefined | EntryInput["mode"];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'EditRowsModal',
  props: {
    value: { type: Boolean, default: false }
  },
  emits: ["input", "update"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", val: boolean): void;
  (e: "update", form: EditForm): void;
}), expose: any, slots: any, attrs: any }) {





const editForm = ref({
    rowsFrom: undefined,
    rowsTo: undefined,
    big: undefined,
    small: undefined,
    mode: undefined,
} as EditForm);

const modeSelectOptions = [
    { label: "Not Edit", value: undefined },
    { label: "R", value: "R" },
    { label: "i", value: "i" },
    { label: "k", value: "k" },
  ];

function toggleModal(val: boolean) {
  emit("input", val);
}

function handleSubmit() {
  const form = editForm.value;
  if (!form.rowsFrom || !form.rowsTo) {
    return;
  }
  if (!form.big && !form.small && !form.mode) {
    return;
  }

  emit("update", editForm.value);
  editForm.value.rowsFrom = undefined;
  editForm.value.rowsTo = undefined;
  editForm.value.big = undefined;
  editForm.value.small = undefined;
  editForm.value.mode = undefined;

  toggleModal(false);
}

return { __sfc: true,emit, editForm, modeSelectOptions, toggleModal, handleSubmit }
}

})